import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';


interface NotificationsListPCPageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    loading?: boolean;
    hasMore?: boolean;
    handleLoadMore?: () => void;
}
interface NotificationsListPCState {
    loading: boolean;
    error: any
    pageLoaded: any
    
}
@inject('app', 'site', 'user', 'activity')
@observer
class NotificationsListPCPage extends BasePage<NotificationsListPCPageProps, NotificationsListPCState> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        
    };
    componentDidMount() {
        super.componentDidMount();
    }

    

    render() {
        let {  } = this.props;

        return (<div className={styles.wrapper}>
            
        </div>)
    }
}

export default withRouter(NotificationsListPCPage);
